var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEverlane = function SvgEverlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#everlane_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.923 16.333v-16H13.73v3.192H4.115v3.192h6.384V9.95H4.115v3.192h9.616v3.192zM27.603 16.333l-6.424-16h3.429l4.61 11.39L33.752.332h3.428l-6.384 16zM45.495 16.333v-16h12.808v3.192h-9.616v3.192h6.384V9.95h-6.384v3.192h9.616v3.192zM79.465 9.318l2.285 7.015H78.4L76.313 9.95h-5.596v6.384h-3.192v-16H77.1a4.8 4.8 0 0 1 3.429 1.38 4.58 4.58 0 0 1 1.38 3.428 4.6 4.6 0 0 1-2.444 4.177m-8.749-2.6H77.1a1.58 1.58 0 0 0 1.143-.473 1.52 1.52 0 0 0 .473-1.143A1.616 1.616 0 0 0 77.1 3.486h-6.384zM91.406 16.333v-16h3.192v12.808h8v3.192zM121.829 13.141h-6.581l-1.3 3.192h-3.429l6.424-16h3.192l6.423 16h-3.428zm-1.3-3.192-2.01-5.005-2.01 5.005zM148.706.333v16h-3.192l-8-10.64v10.64h-3.192v-16h3.192l8 10.64V.334zM158.362 16.333v-16h12.808v3.192h-9.616v3.192h6.384V9.95h-6.384v3.192h9.616v3.192z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "everlane_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.923.333h170.246v16H.923z"
  })))));
};
export default SvgEverlane;